module.exports = __webpack_public_path__ + "static/media/KUSUNDA_official poster 20220221.4790fa92.jpg";